import { ViewportPortal } from "@xyflow/react";
import { AnimatePresence, motion } from "framer-motion";

import EdgeContextMenu from "../../ContextMenu/EdgeContextMenu";

interface EdgePreviewProps {
  id: string;
  isVisible: boolean;
  position: { x: number; y: number } | null;
}

const EdgePreview = ({ id, isVisible, position }: EdgePreviewProps) => {
  if (!isVisible || !position) {
    return null;
  }

  return (
    <ViewportPortal>
      <AnimatePresence>
        <motion.div
          className="pointer-events-none relative z-[1000] w-fit rounded-lg bg-white shadow-lg"
          style={{
            top: position.y - 150,
            left: position.x - 70,
            filter: "blur(0.3px)",
            border: "1px solid #e5e7eb",
            boxShadow: "0 0 15px rgba(156, 163, 175, 0.3), 0 10px 25px -5px rgba(0, 0, 0, 0.1)",
            transform: "scale(0.75)",
          }}
          initial={{ opacity: 0, scale: 0.67, y: -5 }}
          animate={{ opacity: 0.8, scale: 0.71, y: 0 }}
          exit={{ opacity: 0, scale: 0.67, y: -5, filter: "blur(2px)" }}
          transition={{
            duration: 0.15,
            type: "spring",
            stiffness: 400,
            damping: 25,
          }}
        >
          <EdgeContextMenu id={id} isPreview />
        </motion.div>
      </AnimatePresence>
    </ViewportPortal>
  );
};

export default EdgePreview;
